/** @format */

import React, { useState } from "react";
import { Button, Modal, Col } from "react-bootstrap";
import { toast } from "react-toastify";
// import { ReactComponent as AllIcon } from "images/svg/all.svg";
import { ReactComponent as ConfirmedIcon } from "images/svg/confirm.svg";
import { ReactComponent as NotConfirmedIcon } from "images/svg/not.svg";
import { ReactComponent as ResetIcon } from "images/svg/reset.svg";
import { ReactComponent as MarkIcon } from "images/svg/check.svg";

export const FilterModal = ({
  filterData,
  setShowFilter,
  setFilter,
  setFiltered,
}) => {
  const [attendanceMarked, setMarked] = useState(null);
  const [attendanceConfirmed, setConfirmed] = useState(null);

  const handleFilter = () => {
    if (attendanceMarked?.length === 0 && attendanceConfirmed?.length === 0) {
      toast.warn("✔️ Please Select a Filter !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      setFilter({
        attendanceMarked: attendanceMarked?.length > 0 ? attendanceMarked : "",
        attendanceConfirmed:
          attendanceConfirmed?.length > 0 ? attendanceConfirmed : "",
      });
      setFiltered(true);
    }
  };

  return (
    <>
      <Modal
        show={filterData?.showFilter}
        onHide={() => setShowFilter(false)}
        className="modal fade"
        id="postModal"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Fellows</h5>
            <Button
              variant=""
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => setShowFilter(false)}
            >
              <span>×</span>
            </Button>
          </div>
          <div className="modal-body">
            <div className="basic-form">
              <form onSubmit={(e) => e.preventDefault()}>
                <Col>
                  <h6 className="">Attendance Marked</h6>
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className={`filter-option ${
                        attendanceMarked === "yes" ? "selected" : ""
                      } me-2`}
                      onClick={() => setMarked("yes")}
                    >
                      <div className="filter-option-icon">
                        <ConfirmedIcon />
                        {attendanceMarked === "yes" && <MarkIcon />}
                      </div>
                      <div className="filter-option-text">Marked</div>
                    </div>

                    <div
                      className={`filter-option ${
                        attendanceMarked === "no" ? "selected" : ""
                      } me-2`}
                      onClick={() =>  {
                        setMarked("no");
                        setConfirmed("no")
                      }}
                    >
                      <div className="filter-option-icon">
                        <NotConfirmedIcon />
                        {attendanceMarked === "no" && <MarkIcon />}
                      </div>

                      <div className="filter-option-text">Not Marked</div>
                    </div>
                  </div>
                </Col>

                {attendanceMarked === "yes" && (
                  <Col>
                    <h6 className="">Attendance Confirmed</h6>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className={`filter-option ${
                          attendanceConfirmed === "yes" ? "selected" : ""
                        } me-2`}
                        onClick={() => setConfirmed("yes")}
                      >
                        <div className="filter-option-icon">
                          <ConfirmedIcon />
                          {attendanceConfirmed === "yes" && <MarkIcon />}
                        </div>
                        <div className="filter-option-text">Confirmed</div>
                      </div>

                      <div
                        className={`filter-option ${
                          attendanceConfirmed === "no" ? "selected" : ""
                        } me-2`}
                        onClick={() => setConfirmed("no")}
                      >
                        <div className="filter-option-icon">
                          <NotConfirmedIcon />
                          {attendanceConfirmed === "no" && <MarkIcon />}
                        </div>

                        <div className="filter-option-text">Not Confirmed</div>
                      </div>
                    </div>
                  </Col>
                )}
              </form>
            </div>

            <div className="filter-section">
              <div className="filter-group">
                <div className="score-range-container">
                  <button
                    className="reset-filter"
                    onClick={() => {
                      setMarked(null);
                      setConfirmed(null);
                    }}
                  >
                    <ResetIcon />
                    Reset Filter
                  </button>
                  <button
                    className="show-results-button"
                    disabled={
                      attendanceMarked?.length > 0 ||
                      attendanceConfirmed?.length > 0
                        ? false
                        : true
                    }
                    onClick={() => {
                      handleFilter();
                    }}
                  >
                    Show Result
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FilterModal;
